
/**
 * Gets node name from path and name
 * @param string 
 * @returns {} 
 */
export function ExtractNodeName(pathAndName: string): string {
    const lastDelim = pathAndName.lastIndexOf("\\");
    if (lastDelim > -1)
        return pathAndName.substr(lastDelim + 1);
    return pathAndName;

}


export class StringUtils {
    public static isText(data: any): data is string {
        return typeof data === 'string';
    };
}


/**
 * Link property
 */
export class LinkProperty {
    name: string;
    value: number;
    constructor(name: string, value: number) {
        this.name = name;
        this.value = value;
    }

    static propertiesToString = (value: Array<LinkProperty>): string => {
        var result = "";

        value.forEach((curVal) => {
            if (result)
                result = result + ","
            result = result + curVal.name + "=" + curVal.value;
        });

        return result;
    }

    /**
     * Link properties from string
     */
    static propertiesFromString = (value: string): Array<LinkProperty> => {

        var result = [];
        var split = value.split(",");
        split.forEach((curSplit) => {
            var valSplit = curSplit.split("=");
            if (valSplit.length === 2) {
                const asNumber = parseFloat(valSplit[1]);
                if (!isNaN(asNumber)) {
                    const newObj = new LinkProperty(valSplit[0], asNumber);
                    result.push(newObj);
                }
            }
        });
        return result;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.model-utils.ts